import install from './install'

export default {
  install,
}
